import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setInitialEditData } from "../../../../../features/uniqueDefSlice";
import { useEffect, useRef, useState } from "react";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import EditDefinitionRowFiltering from "./EditDefinitionRowFiltering";
import EditDefinitionLookupFields from "./EditDefinitionLookupFields";
import { Paper } from "@mui/material";

const EditDefinition = ({ onRegisterForceRefresh }: any) => {
  const dispatch = useDispatch();
  const { editID } = useSelector((state: any) => state.uniqueDefinition);
  const { loading, uniqueDefinitionDataAll } = useSelector(
    (state: any) => state.uniqueDefinition,
  );
  const [, /*showLookupFieldsEdit*/ setShowLookupFieldsEdit] = useState(false);

  const lookupRef = useRef<any>(null);
  const rowFilteringRef = useRef<any>(null);

  useEffect(() => {
    onRegisterForceRefresh(() => async () => {
      const filteringPayload = rowFilteringRef.current?.refresh() ?? null;
      const lookupPayload = lookupRef.current?.refresh() ?? null;

      return {
        filteringPayload,
        lookupPayload,
      };
    });
  }, [onRegisterForceRefresh]);

  useEffect(() => {
    if (editID && uniqueDefinitionDataAll?.length > 0) {
      const matched = uniqueDefinitionDataAll.find(
        (item: any) => item.id === Number(editID),
      );
      if (matched) {
        dispatch(setInitialEditData(matched));
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueDefinitionDataAll, editID]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper style={{ margin: "15px" }}>
            <EditDefinitionRowFiltering
              setShowLookupFieldsEdit={setShowLookupFieldsEdit}
              ref={rowFilteringRef}
            />
          </Paper>
          <Paper style={{ margin: "15px" }}>
            <EditDefinitionLookupFields ref={lookupRef} />
          </Paper>
        </>
      )}
    </>
  );
};

export default EditDefinition;
